import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { tsmMessageLoader } from './tsm/tsmMessageLoader';
import { isTSMEnabled } from './tsm/tsmHelpers';
const messagesLoaderPropTypes = {
  language: PropTypes.string.isRequired,
  messageLoader: PropTypes.func.isRequired,
  coreMessageLoader: PropTypes.func.isRequired,
  onLoad: PropTypes.func.isRequired
};
export const MessagesLoader = ({
  language,
  messageLoader,
  coreMessageLoader,
  onLoad
}) => {
  useEffect(() => {
    let hasLanguageChanged = false;
    const load = async () => {
      var _context = [];
      const promises = [coreMessageLoader(language), messageLoader(language)];
      if (isTSMEnabled()) {
        promises.push(tsmMessageLoader(language));
      }
      Promise.all(promises).then(results => {
        const messages = _reduceInstanceProperty(_context = results).call(_context, (acc, next) => _Object$assign(acc, next), {});
        if (hasLanguageChanged) {
          return;
        }
        onLoad(messages);
      });
    };
    load();
    return () => {
      hasLanguageChanged = true;
    };
  }, [language, messageLoader, coreMessageLoader, onLoad]);
  return null;
};
MessagesLoader.propTypes = messagesLoaderPropTypes;
MessagesLoader.displayName = 'MessagesLoader';